import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { SkeletonWrapper } from '../../Skeleton';
const BlockSvg = styled.svg.withConfig({
  displayName: "SkeletonThumbnail__BlockSvg",
  componentId: "ha1cat-0"
})(["display:block;"]);

const BlankThumbnailSvg = ({
  backgroundColor
}) => /*#__PURE__*/_jsx(BlockSvg, {
  version: "1.1",
  viewBox: "0 0 1280 720",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Homepage-optimisations",
    stroke: "none",
    strokeWidth: "1",
    children: /*#__PURE__*/_jsx("g", {
      id: "Homepage-Delete-progress",
      transform: "translate(-939.000000, -449.000000)",
      children: /*#__PURE__*/_jsx("g", {
        id: "Ready-to-jump-back-in",
        transform: "translate(134.000000, 393.000000)",
        children: /*#__PURE__*/_jsx("g", {
          id: "Small",
          transform: "translate(2.000000, 50.000000)",
          children: /*#__PURE__*/_jsx("g", {
            id: "Marketing-Copy-3",
            transform: "translate(803.000000, 0.000000)",
            children: /*#__PURE__*/_jsx("g", {
              id: "holding-image",
              transform: "translate(0.000000, 6.000000)",
              children: /*#__PURE__*/_jsx("rect", {
                fill: backgroundColor || '#F5F8FA',
                height: "720",
                id: "Rectangle-Copy",
                rx: "3",
                width: "1280",
                x: "0",
                y: "0"
              })
            })
          })
        })
      })
    })
  })
});

const SkeletonThumbnail = ({
  noShimmer
}) => {
  if (noShimmer) {
    return /*#__PURE__*/_jsx(BlankThumbnailSvg, {});
  }

  return /*#__PURE__*/_jsx(SkeletonWrapper, {
    children: /*#__PURE__*/_jsx(BlankThumbnailSvg, {})
  });
};

export default SkeletonThumbnail;